import React, { useState } from "react";
import { api } from "./api";
import { setAuth } from "./auth";
import PasswordInput from "./PasswordInput";
import { DevCredit } from "./DeveloperCard";

const S = {
  page: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #0f1f3d 0%, #1a3a6b 100%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontFamily: "'Segoe UI', sans-serif",
  },
  card: {
    background: "#fff",
    borderRadius: 12,
    padding: "48px 40px",
    width: "100%",
    maxWidth: 420,
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
  },
  logo: {
    textAlign: "center",
    marginBottom: 32,
  },
  logoTitle: {
    fontSize: 22,
    fontWeight: 700,
    color: "#0f1f3d",
    margin: 0,
  },
  logoSub: {
    fontSize: 13,
    color: "#7f8c8d",
    margin: "4px 0 0",
  },
  label: {
    display: "block",
    fontSize: 12,
    fontWeight: 600,
    color: "#555",
    marginBottom: 6,
    textTransform: "uppercase",
    letterSpacing: "0.5px",
  },
  input: {
    width: "100%",
    padding: "11px 14px",
    border: "1.5px solid #dde1e7",
    borderRadius: 8,
    fontSize: 15,
    boxSizing: "border-box",
    outline: "none",
    transition: "border-color 0.2s",
  },
  group: { marginBottom: 20 },
  btn: {
    width: "100%",
    padding: "13px",
    background: "#1a73e8",
    color: "#fff",
    border: "none",
    borderRadius: 8,
    fontSize: 16,
    fontWeight: 600,
    cursor: "pointer",
    marginTop: 8,
    transition: "background 0.2s",
  },
  error: {
    background: "#fdecea",
    color: "#c0392b",
    border: "1px solid #f5c6cb",
    borderRadius: 8,
    padding: "10px 14px",
    fontSize: 14,
    marginBottom: 16,
  },
};

export default function LoginPage({ onLogin }) {
  const [form, setForm]     = useState({ company_code: "", username: "", password: "" });
  const [error, setError]   = useState("");
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      // Server returns { user } — token is set as HttpOnly cookie automatically
      const { user } = await api.login(
        form.company_code.trim(),
        form.username.trim(),
        form.password,
      );
      setAuth(user);
      onLogin(user);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={S.page}>
      <div style={S.card}>
        <div style={S.logo}>
          <p style={S.logoTitle}>Valuation System</p>
          <p style={S.logoSub}>Property Valuation Management Platform</p>
          <p style={{ margin: "8px 0 0", fontSize: 11, color: "#aab", textAlign: "center", letterSpacing: "0.3px" }}>
            <DevCredit style={{ color: "#aab" }} />
          </p>
        </div>

        {error && <div style={S.error}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={S.group}>
            <label style={S.label}>Company Code</label>
            <input
              style={S.input}
              type="text"
              placeholder="e.g. ABC123"
              value={form.company_code}
              onChange={set("company_code")}
              required
              autoComplete="organization"
            />
          </div>
          <div style={S.group}>
            <label style={S.label}>Username</label>
            <input
              style={S.input}
              type="text"
              placeholder="Enter your username"
              value={form.username}
              onChange={set("username")}
              required
              autoComplete="username"
            />
          </div>
          <div style={S.group}>
            <label style={S.label}>Password</label>
            <PasswordInput
              placeholder="Enter your password"
              value={form.password}
              onChange={set("password")}
              required
              autoComplete="current-password"
            />
          </div>
          <button
            style={{ ...S.btn, opacity: loading ? 0.7 : 1 }}
            type="submit"
            disabled={loading}
          >
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
      </div>
    </div>
  );
}
